import type { TOptions, TPlayer } from 'video.js'

import { uuid } from '@svta/common-media-library'
import { Events } from '|>/shared/events'
import { createLogger } from '|>/shared/logger'

const playbackSessionKey = '~~playbackSessionId'
const logger = createLogger('addons/playback-session')

export function configure(options: TOptions): TOptions {
  return options
}

export function getPlaybackSessionId(player: TPlayer): string | undefined {
  const fromOptions = player.options_?.[playbackSessionKey]
  if (typeof fromOptions === 'string' && fromOptions.length > 0) {
    return fromOptions
  }
  if (
    typeof player.playbackSessionId === 'string' &&
    player.playbackSessionId
  ) {
    return player.playbackSessionId
  }
  return undefined
}

export function setPlaybackSessionId(player: TPlayer, sid: string): void {
  if (!sid) return
  if (!player.options_) player.options_ = {}
  player.options_[playbackSessionKey] = sid
  player.playbackSessionId = sid
  player.trigger(Events.Media.PlaybackSessionId, sid)
  logger.debug('pureya/playback-session set', { sid })
}

export function inject(player: TPlayer): TPlayer {
  if (!player.options_) player.options_ = {}
  const existingSid = getPlaybackSessionId(player)
  if (existingSid) {
    player.options_[playbackSessionKey] = existingSid
    player.playbackSessionId = existingSid
    player.trigger(Events.Media.PlaybackSessionId, existingSid)
    logger.debug('pureya/playback-session inject', { sid: existingSid })
  }

  const onLoad = (_: unknown, payload?: Events.Media.Load) => {
    if (!payload?.src) return
    const nextSid = uuid()
    logger.debug('pureya/playback-session load', {
      src: payload?.src,
      nextSid,
      prevSid: player.playbackSessionId,
    })
    setPlaybackSessionId(player, nextSid)
  }

  player.on(Events.Media.Load, onLoad)
  player.on('dispose', () => {
    player.off(Events.Media.Load, onLoad)
  })
  return player
}
